





























import { Vue, Prop, Component } from 'vue-property-decorator';
import inProductWindow from '@/components/hkTasteBusiness/pc/product/HkProductWindow.vue';
import { swiper, swiperSlide } from 'vue-awesome-swiper/src';
@Component({
  components: {
    inProductWindow,
    swiper,
    swiperSlide
  }
})
export default class PkHotProduct extends Vue {
    hotProducts:any[]=[];
    bannerImg: string = '';
    bannerTitle:string = '';
    LinkUrl:string='';
    ProBanner:string='';
    @Prop() private readonly postionNum!: string;
    @Prop() private readonly swiperClass!: string;
    swiperOption: object = {
      navigation: {
        nextEl: '.swiper-next' + this.swiperClass,
        prevEl: '.swiper-prev' + this.swiperClass
      },
      slidesPerView: 4,
      spaceBetween: 20
    };
    loadHotProducts () {
      var page = 'Home';
      this.$Api.promotion.getPromotion('Home', this.postionNum).then((result) => {
        this.bannerTitle = result.Promotion.Desc;
        this.ProBanner = result.Promotion.ImgPath;
        if (result.Promotion.BannerList.length > 0) {
            this.LinkUrl = result.Promotion.BannerList[0].Url;
        }
        console.log(result, 'resultresult');
        if (result.Promotion.PrmtProductList.length > 0) {
          this.hotProducts = result.Promotion.PrmtProductList.slice(0, 8);
          this.$store.dispatch('setHkPromotion', this.hotProducts);
          this.$store.dispatch('setHkPromotion', this.bannerTitle);
        }
      });
    }
    get currentlang () {
      return this.$i18n.locale;
    }
    mounted () {
      this.loadHotProducts();
    }
}
